module.exports = __webpack_public_path__ + "img/approval.5384a775.svg";